var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "columns" }, [
    _c("div", { staticClass: "column is-narrow" }, [
      _c("h2", { staticClass: "subtitle is-6" }, [_vm._v(" Versions ")]),
      _c(
        "ul",
        [
          _vm._l(_vm.versions, function (v, idx) {
            return _c(
              "li",
              { key: idx, staticStyle: { "margin-bottom": "0.1em" } },
              [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small",
                        class: { "is-success": idx === _vm.currentVersion },
                        on: {
                          click: function ($event) {
                            return _vm.pickVersion(idx)
                          },
                        },
                      },
                      [_vm._m(0, true)]
                    ),
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: v.name,
                          expression: "v.name",
                        },
                      ],
                      staticClass: "input is-small",
                      attrs: { type: "text", placeholder: "Name" },
                      domProps: { value: v.name },
                      on: {
                        change: function ($event) {
                          return _vm.versionChanged(idx)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(v, "name", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-danger is-small",
                        on: {
                          click: function ($event) {
                            return _vm.deleteVersion(idx)
                          },
                        },
                      },
                      [_vm._m(1, true)]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          _c(
            "li",
            {
              staticClass: "has-text-right",
              staticStyle: { "margin-top": "1em" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-primary is-small",
                  attrs: { disabled: !_vm.canAddVersion() },
                  on: {
                    click: function ($event) {
                      return _vm.addVersion()
                    },
                  },
                },
                [_vm._m(2), _c("span", [_vm._v(" Version ")])]
              ),
            ]
          ),
        ],
        2
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "column",
        staticStyle: { "border-left": "1px dotted #c0c0c0" },
      },
      [
        _c("permission-record-childs", {
          attrs: { routes: _vm.getSelectedRoutes() },
          on: {
            addChild: _vm.addRoute,
            accessChanged: _vm.updateRoute,
            deleteRoute: _vm.deleteRoute,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-arrow-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-trash-can-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "mdi mdi-plus mdi-18px",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }